import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

export const getIBTradingAccountFields = (): FieldSettings[] => [
  {
    name: 'Name',
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
    ],
  },
]
